"use client";

import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { LuMail, LuLoader } from "react-icons/lu";

const API = process.env.NEXT_PUBLIC_API_BASE_URL;

export function NewsletterInline() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email: email.trim() });
      setDone(true);
      toast.success("You're subscribed!");
    } catch (err) {
      const message = axios.isAxiosError(err) ? err.response?.data?.message : undefined;
      toast.error(message ?? "Failed to subscribe");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="rounded-2xl bg-indigo-50 dark:bg-indigo-500/10 border border-indigo-100 dark:border-indigo-500/20 p-6 lg:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6">
      <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-indigo-600 shrink-0">
        <LuMail className="w-5 h-5 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-semibold text-gray-900 dark:text-white">Stay updated</h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-0.5">
          Get new articles and scholarship alerts straight to your inbox.
        </p>
      </div>
      {done ? (
        <p className="text-sm font-medium text-indigo-600 dark:text-indigo-400 shrink-0">
          You&apos;re subscribed!
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="flex gap-2 w-full sm:w-auto">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            className="flex-1 sm:w-52 px-3 py-2 rounded-lg bg-white dark:bg-white/10 border border-indigo-200 dark:border-indigo-500/30 text-gray-900 dark:text-white placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400/40 text-sm"
          />
          <button
            type="submit"
            disabled={submitting}
            className="px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-semibold text-sm transition-colors disabled:opacity-60 shrink-0"
          >
            {submitting ? <LuLoader className="w-4 h-4 animate-spin" /> : "Subscribe"}
          </button>
        </form>
      )}
    </section>
  );
}
